module.exports = __webpack_public_path__ + "static/media/android.e5dfcdc6.svg";